export default "__VITE_ASSET__ChXPP0NA__"